// extracted by mini-css-extract-plugin
export default {"ChooseAddContent":"ChooseAdd_ChooseAddContent__V65aI"};